// extracted by mini-css-extract-plugin
export default {"section_articles":"SectionArticles_section_articles__yZYig","articles_layout":"SectionArticles_articles_layout__qJvdC"};